import UserUploadEventStyle from "../UserStyles/UserUploadEventStyle.module.css";
import React, { useState, useEffect } from "react";
import axios from "axios";

const UserUploadEvent = () => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [clubs, setClubs] = useState({});
  const [djNames, setDjNames] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const username = localStorage.getItem("name");
  const [formData, setFormData] = useState({
    club: "",
    eventDate: "",
    eventTime: "",
    eventName: "",
    image: "",
    imageUpload: null,
    numberOfParticipants: 0,
    numberOfTicketsLeft: 0,
    message: "",
    ticketType: "",
    description: "",
    timeOfExpiration: 0,
    prName: "",
    qrTech: "",
    ticketLink: "",
    scanKey: "",
    musicType: [],
    djName: [],
    city: [],
    sponsored: false
  });

  const [tickets, setTickets] = useState([
    {
      type: "Guest List",
      price: "-",
      quantity: "0",
      start: "",
      end: "",
      description: "Write your description here."
    },
    {
      type: "Early Birds",
      price: "10€",
      quantity: 0,
      start: "",
      end: "",
      description: "This Ticket includes the entrance and one drink."
    }
    // Add other ticket types here...
  ]);

  // Handler for when any of the dropdowns or inputs change
  const handleInputChange = (index, field, value) => {
    const newTickets = [...tickets];
    newTickets[index][field] = value;
    setTickets(newTickets);
  };

  const [imageBase64, setImageBase64] = useState("");

  useEffect(() => {
    // Assuming you have a function to load your backend URL
    fetchClubs();
    fetchDjNames();
  }, []);

  const fetchClubs = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/admin/getAllClubs/`);
      if (response.status === 200) {
        setClubs(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch clubs:", error);
    }
  };

  const fetchDjNames = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/admin/getDjNames/`);
      if (response.status === 200) {
        setDjNames(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch DJ names:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setFormData((prevState) => ({
      ...prevState,
      imageUpload: file
    }));
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageBase64(reader.result.toString());
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {
      ...formData,
      image_base64: imageBase64
    };
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${BACKEND_URL}/events/eventsandgroups`,
        dataToSend,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.status === 200) {
        alert("Event submitted successfully");
      } else {
        alert("Submission failed");
      }
    } catch (error) {
      console.error("Error submitting event:", error);
    }
  };

  // Render form with onChange for inputs and onSubmit for the form
  return (
    <div className={UserUploadEventStyle.dashboard}>
      <div className={UserUploadEventStyle.header}>
        <h1>Hello {username}!</h1>
        <p>Welcome back!</p>
      </div>
      <h1 className={UserUploadEventStyle.Title}>Upload a New Event</h1>
      <form
        onSubmit={handleSubmit}
        className={UserUploadEventStyle.formContainer}
      >
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Club
            <select
              name="club"
              value={formData.club}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            >
              {/* Replace with actual club options */}
              <option value="FITZ">FITZ</option>
            </select>
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Number of Participants
            <input
              type="number"
              name="numberOfParticipants"
              value={formData.numberOfParticipants}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Number of Tickets Left
            <input
              type="number"
              name="numberOfTicketsLeft"
              value={formData.numberOfTicketsLeft}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Time of Expiration of Ticket
            <input
              type="number"
              name="timeOfExpirationOfTicket"
              value={formData.timeOfExpirationOfTicket}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Event Date
            <input
              type="date"
              name="eventDate"
              value={formData.eventDate}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
              s
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Event Time
            <input
              type="time"
              name="eventTime"
              value={formData.eventTime}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Event Name
            <input
              type="text"
              name="eventName"
              value={formData.eventName}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Ticket Type
            <select
              name="ticketType"
              value={formData.ticketType}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            >
              <option value="guest list">guest list</option>
              {/* Add other ticket types here */}
            </select>
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            PR Name
            <input
              type="text"
              name="prName"
              value={formData.prName}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            QR Tech
            <select
              name="qrTech"
              value={formData.qrTech}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            >
              <option value="PATT_TECH">PATT_TECH</option>
              {/* Add other QR Tech options here */}
            </select>
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Music Type
            <select
              name="musicType"
              value={formData.musicType}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            >
              {/* Add music type options here */}
            </select>
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            DJ Name
            <select
              name="djName"
              value={formData.djName}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            >
              {/* Add DJ name options here */}
            </select>
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            City
            <select
              name="city"
              value={formData.city}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            >
              {/* Add city options here */}
            </select>
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Message
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>
            Description
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className={UserUploadEventStyle.formInput}
            />
          </label>
        </div>
        <div className={UserUploadEventStyle.formItem}>
          <label className={UserUploadEventStyle.formLabel}>Sponsored:</label>
          <input
            type="checkbox"
            name="sponsored"
            checked={formData.sponsored}
            onChange={handleChange}
            className={UserUploadEventStyle.formInput}
          />
        </div>

        <div
          style={{
            marginBottom: "20px",
            gridColumn: "1 / -1",
            fontSize: "20px"
          }}
        >
          <label className={UserUploadEventStyle.formLabel}>
            Add A Banner Picture
          </label>

          {selectedImage && (
            <div>
              <img
                alt="not found"
                width={"250px"}
                src={URL.createObjectURL(selectedImage)}
              />
              <br />
              <button onClick={() => setSelectedImage(null)}>Remove</button>
            </div>
          )}
          <input
            type="file"
            name="myImage"
            onChange={(event) => {
              console.log(event.target.files[0]);
              setSelectedImage(event.target.files[0]);
            }}
          />
        </div>
        <h1
          style={{
            marginBottom: "20px",
            gridColumn: "1 / -1",
            fontSize: "20px"
          }}
        >
          Add your Ticket Information
        </h1>
        <div style={{ gridColumn: "1 / -1" }}></div>

        <button type="submit">Submit Event & Group Details</button>
      </form>
    </div>
  );
};

/*
const TicketSchema = new mongoose.Schema({
  event: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: mongoose.Schema.Types.ObjectId,
      ref: "Events", // Assuming there's a Club model
      required: true
    }
  },
  timeofexpir: {
    type: Number,
    required: true
  },
  ticketType: {
    type: String,
    enum: [
      "guest list",
      "GIRLS ONLY: guest list",
      "guest list 2nd",
      "guest list 3rd",
      "guest list 4rth",
      "discount entrance: pay online",
      "discount entrance: pay at the door",
      "BOYS: 1ST Paid RELEASE OFFER",
      "GIRLS: 1ST Paid RELEASE OFFER",
      "BOYS: 2ND Paid RELEASE OFFER",
      "GIRLS: 2ND Paid RELEASE OFFER",
      "BOYS: 3RD Paid RELEASE OFFER",
      "GIRLS: 3RD Paid RELEASE OFFER",
      "Early Birds Paid Entrance",
      "Paid Entrance 1st offer",
      "Paid Entrance 2nd offer",
      "Paid Entrance 3rd offer"
    ],
    required: true
  },
  description: {
    type: String,
    required: true
  },
  numberOfTicketsLeft: {
    type: mongoose.Schema.Types.Mixed,
    default: 0
  },
  users_having_ticket: {
    type: Array,
    default: []
  },
  users_having_scanned: {
    type: Array,
    default: []
  },
  users_having_scanned_paid: {
    type: Array,
    default: []
  },
  pr_name: {
    type: String,
    default: "None"
  },
  scan_key: {
    type: String,
    default: ""
  },
  QR_tech: {
    type: String,
    enum: ["PATT", "FOURVENUES", "PATT_TECH"],
    default: ""
  },
  ticket_link: {
    type: String,
    default: ""
  },
  ticket_fourvenues_eventid: {
    type: String,
    default: ""
  },
  users_qrcodes: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  users_eventbrite_tickets: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  users_having_paid: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  price: {
    type: Number,
    default: 0
  },
  isPromoters: {
    type: Boolean,
    default: false
  },
  users_referred_bypromoters: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  promoters_names_ids: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  promoters_names_maxguestlist: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  QRs_fourvenues: {
    type: Array,
    default: []
  },
  supportNumber: {
    type: String,
    default: "34603626679"
  }
});

module.exports = mongoose.model("Tickets", TicketSchema, "Tickets");



*/

export default UserUploadEvent;
